module.exports = __webpack_public_path__ + "static/media/aust_logo.ca462f63.png";